module.exports = __webpack_public_path__ + "img/carryingValueBlue.afd482b6.png";